import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class CommentResource extends AuthenticatedResource {
  static urlRoot = 'profile/:organization_slug/comments';

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}